import OrderApi from '../Api/OrderApi'

const SET_ORDER = 'SET_ORDER'
const START_LOADING = 'START_LOADING'
const STOP_LOADING = 'STOP_LOADING'

const initialState = {
  isLoading: false,
  order: {
    customer: {},
    details: [],
    details_summary: {},
    timestamps: {}
  }
}

export default {
  namespaced: true,
  state: initialState,

  getters: {
    getOrder: state => state.order,
    isLoading: state => state.isLoading
  },

  mutations: {
    [START_LOADING] (state) {
      state.isLoading = true
    },

    [STOP_LOADING] (state) {
      state.isLoading = false
    },

    [SET_ORDER] (state, order) {
      state.order = order
    }
  },

  actions: {
    /**
     * Fetch order
     * 
     * @param {Number} orderId
     * @return {Promise}
     */
    fetchOrder ({ commit }, orderId) {
      commit(START_LOADING)

      return OrderApi.getOrder(orderId)
        .then(response => {
          commit(SET_ORDER, response.data)
        })
        .finally(() => {
          commit(STOP_LOADING)
        })
    }
  }
}
